// extracted by mini-css-extract-plugin
export default {"contentRoot":"index_contentRoot__jmk8P"};